import { useEffect, useState } from "react";
import "./App.css";
import WordList from "./Utils/Wordlist";

function App() {
  const [word, setWord] = useState(null);

  useEffect(() => {
    const loadWords = async () => {
      const wordList = WordList.getInstance();
      await wordList.loadWords();
      setWord(wordList.getRandomWord());
    };

    loadWords().catch(console.error);
  }, []);

  return (
    <div>
      <h2>Zufälliges Wort:</h2>
      <h1>{word ?? "Lädt..."}</h1>
      <button onClick={() => setWord(WordList.getInstance().getRandomWord())}>
        Neues Wort
      </button>
      <br></br>
      <br></br>
      <h2>Bewertung:</h2>
      <label for="rating">Deine Bewertung: </label>

      <input type="number" id="rating" name="rating" min="1" max="10" />
      <br></br>
      <button>Absenden</button>
      <p>Hie rwir dein Test durchgeführt</p>
    </div>
  );
}

export default App;
